import { SessionHeader } from '../components/sessionheader';
import { VotingGrid } from '../components/votinggrid';
import { WinnerBanner } from '../components/winnerbanner';
import { useEffect, useState } from "react";
import { startConnection } from "../services/signalr";

export default function DisplayPage() {
    const [session, setSession] = useState(null);

    useEffect(() => {
        startConnection(setSession);
    }, []);

    if (!session) return <h1>Waiting for session...</h1>;

    return (
        <>
            <SessionHeader session={session} />

            <VotingGrid
                novels={session.suggestions}
                votes={session.votes}
            />

            {!session.isActive && (
                <WinnerBanner session={session} />
            )}
        </>
    );
}
